<core-discussion-sidebar
  [discussions]="discussions()"
  [activeDiscussion]="activeDiscussion()"
  [isLoading]="isLoading()"
  [timeFormat]="timeFormat()"
  [avatarBadgeTemplate]="avatarBadge"
  [participantNameResolver]="getParticipantName"
  [participantInitialResolver]="getParticipantInitial"
  (discussionSelected)="discussionSelected.emit($event)"
  (markAsUnread)="markAsUnread.emit($event)"
  (toggleStar)="toggleStar.emit($event)"
  (archiveDiscussion)="archiveDiscussion.emit($event)"
  (filterTabChanged)="filterTabChanged.emit($event)"
  (scrolledToBottom)="scrolledToBottom.emit()"
>
  <ng-template #avatarBadge let-disc>
    @if (disc.application?.status === 'accepted') {
      <div
        class="absolute bottom-0 right-0 size-3 rounded-full bg-green-9 border-2 border-white dark:border-neutral-2"
      ></div>
    }
  </ng-template>
</core-discussion-sidebar>
